<template>
  <div
    class="flex flex-wrap items-start justify-center gap-2.5 border-t border-gray-300 pb-8 pt-10 text-gray-100 lg:flex-nowrap lg:justify-start lg:gap-0 lg:space-x-3 lg:pb-16 lg:pt-16">
    <span class="mb-6 w-full text-center lg:mb-0 lg:mr-auto lg:text-left">Find us on socials:</span>
    <NuxtLink
      v-for="(link, i) in social"
      :key="i"
      class="group relative box-border flex h-14 w-14 flex-shrink-0 items-center justify-center rounded-full border border-white"
      target="_blank"
      rel="noreferrer"
      :to="link.url"
      @click="handleClick(link.title)">
      <span class="sr-only">{{ link.title }}</span>
      <component
        :is="`Icon${link.icon}`"
        class="h-5" />
      <span
        class="icon-container absolute inset-[-1px] rounded-full opacity-0 mix-blend-multiply transition-opacity duration-200 group-hover:opacity-100" />
    </NuxtLink>
  </div>
</template>

<script setup lang="ts">
  import { useNuxtApp } from '#imports'

  import social from '../../content/navigation/social.json'

  const { $event } = useNuxtApp()

  function handleClick(linkTitle: string) {
    $event('Link', { props: { Footer: linkTitle } })
  }
</script>
